<template>
    <div class="circular-progress">
        <svg :width="size" :height="size">
            <defs v-if="use_gradient">
                <linearGradient :id="`grad-${color.replace('#','')}`" x1="0%" y1="0%" x2="100%" y2="0%">
                    <stop offset="0%" :stop-color="color" />
                    <stop offset="100%" stop-color="white" stop-opacity="0.3" />
                </linearGradient>
            </defs>

            <!-- Fondo gris -->
            <circle
                :r="radius"
                :cx="size/2"
                :cy="size/2"
                :stroke-width="stroke"
                stroke="#eee"
                fill="transparent"
            />

            <!-- Borde negro -->
            <circle
                :r="radius"
                :cx="size/2"
                :cy="size/2"
                :stroke-width="stroke + 2"
                :stroke="border_color"
                fill="transparent"
                stroke-linecap="round"
                :stroke-dasharray="circumference"
                :stroke-dashoffset="dash_offset"
                :transform="`rotate(-90, ${size/2}, ${size/2})`"
            />

            <!-- Segmento de valor -->
            <circle
                :r="radius"
                :cx="size/2"
                :cy="size/2"
                :stroke-width="stroke"
                :stroke="use_gradient ? `url(#grad-${color.replace('#','')})` : color"
                fill="transparent"
                stroke-linecap="round"
                :stroke-dasharray="circumference"
                :stroke-dashoffset="dash_offset"
                :transform="`rotate(-90, ${size/2}, ${size/2})`"
                style="transition: stroke-dashoffset 0.3s linear"
            />

            <!-- Texto central -->
            <text
                x="50%"
                y="50%"
                text-anchor="middle"
                dominant-baseline="middle"
                font-size="20"
                :fill="color"
            >
                {{ animated_value }}%
            </text>
        </svg>
    </div>
</template>

<script setup>
    import { computed, ref, onMounted } from "vue"

    const props = defineProps({
        value: { type: Number, required: true },            // porcentaje final
        size: { type: Number, default: 120 },               // tamaño en px
        stroke: { type: Number, default: 12 },              // grosor
        color: { type: String, default: "#4caf50" },        // color base
        use_gradient: { type: Boolean, default: false },    // alternar entre color fijo y gradient
        border_color: { type: String, default: "#343a40" }  // borde exterior
    })

    const radius = computed(() =>
        (props.size - (props.stroke + 2)) / 2
    )
    const circumference = computed(() => 2 * Math.PI * radius.value)

    const animated_value = ref(0)

    onMounted(() => {
        let start_value = 0
        const animateValue = () => {
            if (start_value < props.value) {
                start_value++
                animated_value.value = start_value
                requestAnimationFrame(animateValue)
            }
        }
        requestAnimationFrame(animateValue)
    })

    const dash_offset = computed(() =>
        circumference.value - (animated_value.value / 100) * circumference.value
    )
</script>
